import type { Range } from 'slate';
import { Editor, Text } from 'slate';

import type { TabElement } from '../internal';
import { AlineTransforms, createDefaultText, Queries } from '../internal';
import type { EditingMode } from '../types';

const TabTransforms = {
  insertTabElement: (
    editor: Editor,
    options: {
      authorId: string;
      editingMode: EditingMode;
      at?: Range;
    }
  ) => {
    AlineTransforms.withoutNormalizing(editor, () => {
      const { at = editor.selection, authorId, editingMode } = options;
      if (!at) return;

      const textEntryBefore = Editor.previous(editor, {
        at,
        match: Text.isText,
        mode: 'lowest',
        voids: false,
      });
      const textProps = textEntryBefore ? Queries.getActiveTextProps(textEntryBefore[0]) : {};

      AlineTransforms.insertContentNodes(editor, {
        at,
        authorId,
        editingMode,
        nodes: [
          {
            children: [createDefaultText(textProps, '')],
            suggestedEdits: [],
            type: 'tab',
          } satisfies TabElement,
        ],
        select: 'end',
      });
    });
  },
};

export default TabTransforms;
